import React, { useState } from 'react';
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import DataGridTable from '../DataGrid';
import { handleValidateCodevalue, ROWS_TO_VIEW_IN_CHILD_TABLE } from '../../Utility/constant';
import LeadDialog from '../LeadDialog';
import ActionablesCalendar from './ActionablesCalendar';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import './ActionablesTabs.css';

const INITIAL_UI_STATE = { selectedTab: 'FOR_TODAY', isCalendarOpen: false };

const ActionablesTabs = ({
    allData,
    internationalise,
    columns,
    todayData,
    nextDaysData,
    isLoading,
    getRowClassName,
    renderValuesOnCard,
    titleField = "taskId",
    handleOnClickCard,
    handleMarkAsRead,
    isLead = true,
    isCalendarOpen: externalIsCalendarOpen,
    onCloseCalendar: externalOnCloseCalendar
}) => {
    const [uiState, setUiState] = useState(INITIAL_UI_STATE);

    const isMobile = useIsMobile();
    const isCalendarOpen = externalIsCalendarOpen !== undefined ? externalIsCalendarOpen : uiState.isCalendarOpen;
    const handleCloseCalendar = externalOnCloseCalendar || (() => setUiState(prev => ({ ...prev, isCalendarOpen: false })));

    const handleChange = (event, newValue) => {
        setUiState(prev => ({ ...prev, selectedTab: newValue }));
    };

    return (
        <Box className="actionables-tabs-root">
            <TabContext value={uiState.selectedTab}>
                <Box className="actionables-tabs-sub-bar">
                    <TabList
                        onChange={handleChange}
                        variant="standard"
                        aria-label="actionables date filter"
                        allowScrollButtonsMobile
                    >
                        <Tab
                            value="FOR_TODAY"
                            key="FOR_TODAY"
                            label={handleValidateCodevalue(internationalise, "FOR_TODAY")}
                        />
                        <Tab
                            value="FOR_NEXT_TWO_MONTHS"
                            key="FOR_NEXT_TWO_MONTHS"
                            label={handleValidateCodevalue(internationalise, "FOR_NEXT_TWO_MONTHS") || "For Next 2 Months"}
                        />
                    </TabList>
                </Box>

                <TabPanel value="FOR_TODAY">
                    <DataGridTable
                        isLead={isLead}
                        handleMarkAsRead={handleMarkAsRead}
                        handleOnClickCard={handleOnClickCard}
                        renderValuesOnCard={renderValuesOnCard}
                        titleField={titleField}
                        key="today-grid"
                        columns={columns}
                        isLoading={isLoading}
                        isRequiredToolBar={false}
                        dataGridData={todayData}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height="calc(100vh - 465px)"
                        isCheckboxReq={false}
                        getRowClassName={getRowClassName}
                    />
                </TabPanel>

                <TabPanel value="FOR_NEXT_TWO_MONTHS">
                    <DataGridTable
                        isLead={isLead}
                        handleMarkAsRead={handleMarkAsRead}
                        handleOnClickCard={handleOnClickCard}
                        renderValuesOnCard={renderValuesOnCard}
                        titleField={titleField}
                        key="next-months-grid"
                        columns={columns}
                        isLoading={isLoading}
                        isRequiredToolBar={false}
                        dataGridData={nextDaysData}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height="calc(100vh - 465px)"
                        isCheckboxReq={false}
                        getRowClassName={getRowClassName}
                    />
                </TabPanel>
            </TabContext>

            {/* Calendar Modal Dialog */}
            {!isMobile && (
                <LeadDialog
                    open={Boolean(isCalendarOpen)}
                    handleClose={handleCloseCalendar}
                    size="xl"
                    title={handleValidateCodevalue(internationalise, "DB_ACTIONABLES_CAL_TITLE") || (isLead ? 'Lead Actionables Calendar' : 'Task Actionables Calendar')}
                    hideActions
                    paperProps={{
                        className: 'actionables-calendar-dialog-paper'
                    }}
                >
                    <Box className="actionables-calendar-dialog__scroll">
                        <ActionablesCalendar
                            data={allData}
                            internationalise={internationalise}
                            isLead={isLead}
                            handleOnClickCard={(item) => {
                                if (handleOnClickCard) handleOnClickCard(item);
                            }}
                            isLoading={isLoading}
                        />
                    </Box>
                </LeadDialog>
            )}
        </Box>
    );
};

export default ActionablesTabs;
